/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = { rescheduleStatus: null };

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.AddReschduleSlotAction.REQUEST_RESCHEDULESLOT:
      return {
        ...state
      };
    case actions.AddReschduleSlotAction.RESCHEDULESLOT_RECEIVED:
      return {
        ...state,
        rescheduleStatus: action.data
      };

    case actions.AddReschduleSlotAction.CLEAR_RESCHEDULESLOT:
      return {
        ...state,
        rescheduleStatus: null
      };

    default:
      return state;
  }
};

export default reducer;
